// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6114242e","707":"694d94d1","845":"cbe58abd"}[chunkId] + ".chunk.js";
};